import {
    AlarmTypesFilter,
    LocationsFilter,
    NO_TRAININGS,
    OperatorsFilterFields,
    TrainingStagesFilter,
} from '@root/src/modules/operators/types/operators-filter.type.ts';
import { NO_LOCATIONS } from 'core/contexts/locations/location.constants';
import { Location } from 'core/contexts/locations/location.model';
import { OperatorsFilterFieldsQuery } from 'modules/operators/pods/private-pods/operators-list/operators-filter/types/operator-filter-fields-query.type';
import { CustomFieldFilterCriteria } from 'modules/operators/pods/private-pods/operators-list/operators-filter/types/search-filter-criteria.type';
import { NO_STATUS } from '@root/src/commons-app/components/alarm-filter/alarm-filter.constants.ts';

export const mapOperatorListFiltersFromVmtoApi = (
    filterFields: OperatorsFilterFields,
    locations: Location[]
): OperatorsFilterFieldsQuery => {
    const fields: OperatorsFilterFieldsQuery = {};

    fields.active = filterFields.active;
    fields.withStatus = mapAlarmTypes(filterFields.alarmType);
    fields.withLocations = mapLocations(locations, filterFields.locationsLevel1, filterFields.locationsLevel2);
    fields.withTrainingStages = mapTrainingStages(filterFields.trainingStages);
    fields.withNameBadgeId = mapNameBadgeidStages(filterFields.nameBadgeid);

    fields.withCustomFieldMatching = mapCustomFields(filterFields.customFields);

    return fields;
};

export const mapAlarmTypes = (alarmType: string[] = []): AlarmTypesFilter | undefined => {
    if (!alarmType.length) {
        return undefined;
    }

    const status = alarmType.filter((v) => v !== NO_STATUS);
    const noAlarms = alarmType.includes(NO_STATUS);

    return { noAlarms, status };
};

export const mapLocations = (
    locations: Location[],
    locationsLevel1: string[] = [],
    locationsLevel2: string[] = []
): LocationsFilter | undefined => {
    if (!locationsLevel1.length && !locationsLevel2.length) {
        return undefined;
    }

    const locationsSelected: string[] = locations
        .filter((location) => locationsLevel1?.includes(location.id))
        .flatMap((location) => location.children ?? [])
        .map((location) => location?.id);

    const locationsFilter: LocationsFilter = {
        noLocations: locationsLevel1.includes(NO_LOCATIONS) || locationsLevel2.includes(NO_LOCATIONS),
        locations: Array.from(new Set([...locationsSelected, ...locationsLevel2.filter((l) => l !== NO_LOCATIONS)])),
    };

    return locationsFilter;
};

export const mapTrainingStages = (trainingStages: string[] = []): TrainingStagesFilter | undefined => {
    if (!trainingStages.length) {
        return undefined;
    }

    const trainingStagesFilter: TrainingStagesFilter = {
        noTrainingStages: trainingStages.includes(NO_TRAININGS),
        trainingStages: trainingStages.filter((ts) => ts !== NO_TRAININGS),
    };

    return trainingStagesFilter;
};

export const mapNameBadgeidStages = (nameBadgeidStages: string[] = []): string[] | undefined => {
    if (!nameBadgeidStages.length) {
        return undefined;
    }

    return nameBadgeidStages;
};

export const mapCustomFields = (
    customFields: CustomFieldFilterCriteria[] = []
): CustomFieldFilterCriteria[] | undefined => {
    if (!customFields.length) {
        return undefined;
    }

    return customFields;
};
